import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { changeTab } from "../../actions/general";
import { getNavTab } from "../../utilities/helpers";

export default function ScrollToTop() {
  const { pathname } = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(changeTab(getNavTab(pathname)));
  }, [dispatch, pathname]);

  return null;
}
